<template>
  <div>
    <generic-table
      ref="datatable"
      :show_refresh="false"
      :title="$t('point of sale')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/gym_pos/product/datatables"
      @selected="$emit('selected', $event)"
      :page_length="25"
      mode="grid"
    >
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <figure
              class="image is-64x64 m-auto"
              @click="$emit('selected', item)"
            >
              <v-lazy-image
                v-if="item.image"
                :src="`${api_host}/drive/static/${item.image}`"
              />
              <img
                v-else
                src="https://icon-library.com/images/product-icon-png/product-icon-png-11.jpg"
              />
            </figure>
          </div>
          <div class="card-content px-0" @click="$emit('selected', item)">
            <div class="media">
              <div class="media-content">
                <div class="title is-5 has-text-centered">
                  {{ item.name }}
                </div>
                <div class="subtitle is-6 has-text-centered">
                  <div class="tag is-primary is-medium">
                    {{ format_currency(item.sale_price) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </generic-table>
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  api_host,
  format_currency,
} from "@/utils";
import VLazyImage from "v-lazy-image";
// import ProductModal from "./product_modal/Index.vue";

export default {
  name: "OrdersDatatable",
  components: { GenericTable, VLazyImage },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        {
          text: v.$t("sales"),
          icon: "fa fa-list",
          class: "is-rounded",
          click: function () {
            v.$router.push({ path: "/gym_pos/sale" });
          },
        },
      ],
      columns: [
        {
          orderable: false,
          title: v.$t("barcode"),
          name: "barcode",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.barcode || "";
          },
        },
        {
          orderable: false,
          title: v.$t("name"),
          name: "name",
          width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          orderable: false,
          title: v.$t("sale price"),
          name: "sale_price",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.sale_price) || "";
          },
        },
        // {
        //   title: v.$t("options"),
        //   searchable: false,
        //   data: (row) => {
        //     return generate_datatables_buttons([
        //       {
        //         args: { uuid: row.uuid },
        //         tooltip: v.$t("edit"),
        //         icon: "fa fa-edit",
        //         icon_class: "is-small",
        //         click: function (e) {
        //           console.log("edit order", e.detail.uuid);
        //           v.$refs.product_modal.show_modal(e.detail.uuid);
        //         },
        //       },
        //       {
        //         args: { uuid: row.uuid },
        //         tooltip: v.$t("delete"),
        //         icon: "fa fa-trash",
        //         icon_class: "is-small has-text-danger",
        //         click: (e) => {
        //           let uuid = e.detail.uuid;
        //           confirm_deletion_dialog(
        //             v.$t("are you sure to delete product?"),
        //             v,
        //             () => {
        //               del("/product", { uuid: uuid })
        //                 .then(() => {
        //                   v.refresh();
        //                 })
        //                 .catch((error) => {
        //                   error_message(error);
        //                 });
        //             }
        //           );
        //         },
        //       },
        //     ]);
        //   },
        // },
      ],
    };
  },
  methods: {
    format_currency,
    // create() {
    //   let v = this;
    //   v.$refs.product_modal.show_modal();
    // },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
